var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrongSoting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1563_9556)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1563_9556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 0.400391H9.5999C4.51888 0.400391 0.399902 4.51937 0.399902 9.60039V70.4004C0.399902 75.4814 4.51888 79.6004 9.5999 79.6004H70.3999C75.4809 79.6004 79.5999 75.4814 79.5999 70.4004V9.60039C79.5999 4.51937 75.4809 0.400391 70.3999 0.400391Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1699 31.4658V46.3517H9.43213V41.9355C9.43213 41.852 9.43573 41.7686 9.44301 41.6851C9.51474 40.8808 9.92592 40.1391 10.5849 39.6589C10.8845 39.4411 11.2022 39.2269 11.4927 39.0218C11.8558 38.7648 12.1762 38.5234 12.3586 38.3128C12.955 37.6247 14.5699 34.7808 15.8997 32.9916C17.2304 31.2024 18.8363 31.1563 18.8363 31.1563H25.8602C26.0313 31.1562 26.1699 31.2949 26.1699 31.4658Z",
    fill: "#669999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1009 32.0757V37.0355C22.1009 37.1733 22.0096 37.2903 21.8831 37.3283C21.8546 37.3378 21.8242 37.3426 21.7928 37.3426H14.2971C14.1307 37.3426 14.0299 37.1591 14.1193 37.0183C14.7307 36.0646 15.5456 34.7296 16.2901 33.6874C16.3624 33.5857 16.4347 33.4868 16.506 33.3907C16.7313 33.0874 16.9652 32.8411 17.1963 32.6415C17.3884 32.4741 17.5795 32.34 17.7611 32.2307C18.0255 32.0709 18.2727 31.9673 18.48 31.8988C18.8546 31.7742 19.1028 31.7676 19.1028 31.7676L21.7928 31.7676C21.963 31.7676 22.1009 31.9055 22.1009 32.0757Z",
    fill: "#DAE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5175 32.0196V37.0915C25.5175 37.2303 25.4053 37.3426 25.2665 37.3426H22.9283C22.9064 37.3426 22.8845 37.3397 22.8646 37.334C22.7771 37.3112 22.7086 37.2427 22.6858 37.1552C22.6801 37.1353 22.6772 37.1134 22.6772 37.0915V32.0196C22.6772 31.8912 22.7742 31.7838 22.8988 31.7695C22.9083 31.7686 22.9178 31.7676 22.9283 31.7676L25.2665 31.7676C25.4053 31.7676 25.5175 31.8808 25.5175 32.0196Z",
    fill: "#DAE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1698 46.3516H9.43213V47.8654H51.1698V46.3516Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95908 48.1115H9.24642C9.11032 48.1115 9 48.0012 9 47.8651V46.3108C9 46.1748 9.11032 46.0645 9.24642 46.0645L9.95908 46.0645C10.007 46.0645 10.0458 46.1033 10.0458 46.1511V48.0248C10.0458 48.0727 10.007 48.1115 9.95908 48.1115Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.067 28.334H27.9928C27.5068 28.334 27.1128 28.7279 27.1128 29.2139V46.352H50.947V29.2139C50.947 28.7279 50.5531 28.334 50.067 28.334Z",
    fill: "#FF8331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6061 47.8648H39.5396C39.5881 47.3276 39.7298 46.8179 39.9494 46.351C40.6759 44.8021 42.2496 43.7285 44.0733 43.7285C45.8971 43.7285 47.4708 44.8021 48.1963 46.351C48.4159 46.8179 48.5576 47.3276 48.6061 47.8648Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1361 48.2819C48.1361 50.526 46.3169 52.3451 44.0729 52.3451C41.8289 52.3451 40.0098 50.526 40.0098 48.2819C40.0098 46.0378 41.8289 44.2188 44.0729 44.2188C46.3169 44.2188 48.1361 46.0379 48.1361 48.2819Z",
    fill: "#669999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3175 48.2818C47.3175 50.0738 45.8647 51.5264 44.0728 51.5264C42.2808 51.5264 40.8281 50.0738 40.8281 48.2818C40.8281 46.4897 42.2808 45.0371 44.0728 45.0371C45.8647 45.0371 47.3175 46.4898 47.3175 48.2818Z",
    fill: "#E7ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2119 48.2819C46.2119 49.4635 45.254 50.4213 44.0725 50.4213C42.8909 50.4213 41.9331 49.4635 41.9331 48.2819C41.9331 47.1004 42.8909 46.1426 44.0725 46.1426C45.2541 46.1426 46.2119 47.1004 46.2119 48.2819Z",
    fill: "#669999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3647 48.2824C45.3647 48.996 44.7862 49.5745 44.0725 49.5745C43.3588 49.5745 42.7803 48.996 42.7803 48.2824C42.7803 47.5687 43.3588 46.9902 44.0725 46.9902C44.7862 46.9902 45.3647 47.5687 45.3647 48.2824Z",
    fill: "#E7ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84087 43.6369H9.34643C9.24947 43.6369 9.1709 43.5584 9.1709 43.4614V42.2694C9.1709 42.1724 9.24947 42.0938 9.34643 42.0938H9.84087C9.99127 42.0938 10.1132 42.2157 10.1132 42.3661V43.3646C10.1132 43.515 9.99125 43.6369 9.84087 43.6369Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93081 44.5339H9.34643C9.24947 44.5339 9.1709 44.4554 9.1709 44.3584V44.0173C9.1709 43.9204 9.24947 43.8418 9.34643 43.8418H9.93081C10.0315 43.8418 10.1132 43.9235 10.1132 44.0242V44.3515C10.1132 44.4524 10.0315 44.534 9.93081 44.5339Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1702 39.0215V41.6848H9.44336C9.51509 40.8806 9.92627 40.1389 10.5853 39.6587C10.8849 39.4408 11.2026 39.2266 11.4931 39.0215L26.1702 39.0215Z",
    fill: "#83ACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3499 38.1939H13.3317C13.266 38.1939 13.2129 38.1407 13.2129 38.0751V37.7693C13.2129 37.7037 13.266 37.6504 13.3317 37.6504H14.3499C14.4156 37.6504 14.4688 37.7037 14.4688 37.7693L14.4688 38.0751C14.4688 38.1407 14.4156 38.1939 14.3499 38.1939Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8152 36.2148C14.8023 36.2205 14.5168 36.3356 14.223 36.6046C14.0763 36.7392 13.9275 36.9133 13.8146 37.1327C13.7018 37.3518 13.6263 37.6169 13.6265 37.9228H14.0068C14.0071 37.6789 14.0653 37.4777 14.153 37.3065C14.2842 37.0506 14.4866 36.8628 14.6583 36.7408C14.7438 36.6798 14.8211 36.6354 14.8758 36.6068C14.9031 36.5925 14.9248 36.5822 14.939 36.5757L14.9546 36.5688L14.9578 36.5674L14.953 36.556L14.9577 36.5674H14.9578L14.953 36.556L14.9577 36.5674L14.8152 36.2148Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8831 37.3275C21.8545 37.337 21.8241 37.3417 21.7927 37.3417H19.9452L16.29 33.6866C16.3623 33.5848 16.4346 33.486 16.5059 33.3899C16.7312 33.0866 16.9651 32.8403 17.1962 32.6406L21.8831 37.3275Z",
    fill: "#F2FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.101 35.5194V36.5701L17.7612 32.2303C18.0256 32.0706 18.2728 31.9669 18.4801 31.8984L22.101 35.5194Z",
    fill: "#F2FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5176 33.3365V34.3882L22.8989 31.7695C22.9084 31.7686 22.9179 31.7676 22.9284 31.7676L23.9487 31.7676L25.5176 33.3365Z",
    fill: "#F2FBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2898 36.1757C15.6191 36.7487 15.8648 37.2253 15.6196 37.3662C15.3744 37.5072 14.9086 37.1571 14.5793 36.5842C14.2499 36.0113 14.1818 35.4325 14.427 35.2916C14.6723 35.1506 14.9605 35.6028 15.2898 36.1757Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8976 47.8648H10.8311C10.8796 47.3276 11.0212 46.8179 11.2409 46.351C11.9674 44.8021 13.5411 43.7285 15.3648 43.7285C17.1886 43.7285 18.7623 44.8021 19.4878 46.351C19.7074 46.8179 19.8491 47.3276 19.8976 47.8648Z",
    fill: "#336666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4277 48.2819C19.4277 50.526 17.6084 52.3451 15.3645 52.3451C13.1204 52.3451 11.3013 50.526 11.3013 48.2819C11.3013 46.0378 13.1204 44.2188 15.3645 44.2188C17.6084 44.2188 19.4276 46.0379 19.4277 48.2819Z",
    fill: "#669999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.609 48.2818C18.609 50.0738 17.1562 51.5264 15.3643 51.5264C13.5723 51.5264 12.1196 50.0738 12.1196 48.2818C12.1197 46.4897 13.5723 45.0371 15.3643 45.0371C17.1562 45.0371 18.609 46.4898 18.609 48.2818Z",
    fill: "#E7ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5039 48.2819C17.5039 49.4635 16.546 50.4213 15.3645 50.4213C14.1829 50.4213 13.2251 49.4635 13.2251 48.2819C13.2251 47.1004 14.1829 46.1426 15.3645 46.1426C16.5461 46.1426 17.5038 47.1004 17.5039 48.2819Z",
    fill: "#669999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6567 48.2824C16.6567 48.996 16.0781 49.5745 15.3645 49.5745C14.6508 49.5745 14.0723 48.996 14.0723 48.2824C14.0723 47.5687 14.6508 46.9902 15.3645 46.9902C16.0781 46.9902 16.6567 47.5687 16.6567 48.2824Z",
    fill: "#E7ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8779 49.3164H29.6753V58.3283H39.8779V49.3164Z",
    fill: "#F7C176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4923 49.3164H38.75V58.3283H44.4923V49.3164Z",
    fill: "#DEAE6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7523 50.2871H36.189V56.048H37.7523V50.2871Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2235 50.2871H30.395V50.8006H35.2235V50.2871Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2235 50.9707H30.395V51.4838H35.2235V50.9707Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9233 44H13.79V51.7021H24.9233V44Z",
    fill: "#E1B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.959 44H23.6929V51.7021H29.959V44Z",
    fill: "#C89D5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 46.7341H21.9025L23.6929 44H13.7902L12 46.7341Z",
    fill: "#F9CD90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2004 46.7341H25.431L23.6406 44H30.4101L32.2004 46.7341Z",
    fill: "#F9CD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7418 47.5371H14.4243V50.0456H22.7418V47.5371Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4868 51.0879H12.832V60.0998H25.4868V51.0879Z",
    fill: "#F7C176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2103 51.0879H24.0879V60.0998H31.2103V51.0879Z",
    fill: "#DEAE6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8512 52.0566H20.9121V57.8175H22.8512V52.0566Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.714 52.0566H13.7251V52.5702H19.714V52.0566Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.714 52.7422H13.7251V53.2553H19.714V52.7422Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9243 50.9902H60.2666V57.7542H67.9243V50.9902Z",
    fill: "#F7C176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3875 50.9902H67.0776V57.7542H71.3875V50.9902Z",
    fill: "#DEAE6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3292 51.7188H65.1558V56.0426H66.3292V51.7188Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4307 51.7188H60.8066V52.1042H64.4307V51.7188Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4307 52.2324H60.8066V52.6175H64.4307V52.2324Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7 47H48.3438V52.7809H56.7V47Z",
    fill: "#E1B679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4795 47H55.7764V52.7809H60.4795V47Z",
    fill: "#C89D5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 49.0521H54.4324L55.7762 47H48.3437L47 49.0521Z",
    fill: "#F9CD90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1615 49.0521H57.0806L55.7368 47H60.8177L62.1615 49.0521Z",
    fill: "#F9CD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0626 49.6562H48.8198V51.539H55.0626V49.6562Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1227 52.3184H47.6245V59.0823H57.1227V52.3184Z",
    fill: "#F7C176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4185 52.3184H56.0728V59.0823H61.4185V52.3184Z",
    fill: "#DEAE6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1444 53.0469H53.689V57.3707H55.1444V53.0469Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79 53.0469H48.2949V53.4323H52.79V53.0469Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79 53.5605H48.2949V53.9457H52.79V53.5605Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6485 36.3931C54.8504 33.1913 54.8504 28.0001 51.6485 24.7983C48.4467 21.5965 43.2556 21.5965 40.0537 24.7983C36.8519 28.0001 36.8519 33.1913 40.0537 36.3931C43.2556 39.5949 48.4467 39.5949 51.6485 36.3931Z",
    fill: "#99FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1884 26.2578C50.54 26.6093 50.54 27.1844 50.1884 27.5359L42.7933 34.9311C42.4418 35.2826 41.8666 35.2826 41.5151 34.9311C41.1636 34.5796 41.1636 34.0045 41.5151 33.6529L48.9103 26.2578C49.2618 25.9063 49.8369 25.9063 50.1884 26.2578Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1885 34.9311C49.8369 35.2826 49.2618 35.2826 48.9103 34.9311L41.5151 27.5359C41.1636 27.1844 41.1636 26.6093 41.5151 26.2578C41.8666 25.9063 42.4418 25.9063 42.7933 26.2578L50.1884 33.6529C50.54 34.0045 50.54 34.5796 50.1885 34.9311Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1563_9556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongSoting);
export default __webpack_public_path__ + "static/media/wrongSoting.96308ffade9af04cf77c46a4b59be485.svg";
export { ForwardRef as ReactComponent };